import { Box } from '@mui/material';

import { Status } from '@sh4res/bo-common/components/B2bEmployeeBulkCreate/components/bulkUploadStatus';

const labelStyle = {
  position: 'absolute' as const,
  transform: 'translateX(-50%)',
};

const sumPercentageBefore = (statuses: Status[], index: number, initial = 0) =>
  statuses.reduce(
    (totalLeft, previousStatus, previousStatusIndex) =>
      previousStatusIndex < index ? totalLeft + previousStatus.percentage : totalLeft,
    initial,
  );

export function BulkUploadProgressBar({ statuses }: { statuses: Status[] }) {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#f0f0f0',
        borderRadius: '5px',
        overflow: 'hidden',
        height: '20px',
        position: 'relative',
        mb: 2,
      }}>
      {statuses.map((status, statusIndex) => (
        <Box
          key={status.name}
          sx={{
            backgroundColor: status.color,
            height: '100%',
            width: `${status.percentage}%`,
            position: 'absolute',
            left: `${sumPercentageBefore(statuses, statusIndex)}%`,
            transition: 'width 0.5s ease, left 0.5s ease',
          }}
        />
      ))}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#ffffff',
          fontSize: '12px',
          fontWeight: 'bold',
          height: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}>
        {statuses.map((status, statusIndex) => (
          <span
            key={status.name}
            style={{
              ...labelStyle,
              left: `${sumPercentageBefore(statuses, statusIndex, status.percentage / 2)}%`,
              opacity: status.percentage === 0 ? 0 : 1,
              transition: 'left 0.5s ease, opacity 0.5s ease',
            }}>
            {status.percentage}%
          </span>
        ))}
      </Box>
    </Box>
  );
}
